module.exports = __webpack_public_path__ + "static/media/ApercuPro-Light.a289cefa.woff2";